// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0293e3c3","236":"4abcaa5f","703":"6279e78b","787":"a4b45000"}[chunkId] + ".chunk.js";
};